import {
  POPULATE_STUDENT_SEARCH_FILTERS,
  POPULATE_STUDENT_SEARCH_DISTRICT_INFO,
  SET_STUDENT_SEARCH_SEARCH_FILTERS,
  UPDATE_STUDENT_SEARCH_BUSY_RETRIEVING_STUDENTS,
  POPULATE_STUDENT_SEARCH_RESULTS,
  CHANGE_STUDENT_SEARCH_PAGE,
  CHANGE_STUDENT_SEARCH_STUDENTS_PER_PAGE,
  CHANGE_STUDENT_SEARCH_SORT_MODE,
  CHANGE_STUDENT_SEARCH_TERM,
} from 'modules/StudentSearchSidebar/constants';

const initialState = {
  // these are the possible filtering options, from which a counselor can choose
  filteringOptions: {
    schools: [],
    caseloads: [],
    grades: [],
    officialTags: [],
    personalTags: [],
  },

  // these are the filters that a counselor chose
  activeFilters: {
    schools: {},
    caseloads: {},
    grades: {},
    officialTags: {},
    personalTags: {},
  },

  // district info
  district: {},

  // search results
  isBusyRetrievingStudents: false,
  students: undefined,
  studentCount: 0,
  studentSearchTerm: '',

  // pagination controls
  page: 1,
  studentsPerPage: 10,
  orderBy: 'last_login',
  order: '-',
  hasNextPage: false,
  hasPrevPage: false,
};

// eslint-disable-next-line complexity
function counselorDashboardReducer(state = initialState, action) {
  switch (action.type) {
    case POPULATE_STUDENT_SEARCH_FILTERS:
      return {
        ...state,
        filteringOptions: {
          schools: action.schools || [],
          caseloads: action.caseloads || [],
          grades: action.grades || [],
          officialTags: action.officialTags || [],
          personalTags: action.personalTags || [],
        },
      };
    case POPULATE_STUDENT_SEARCH_DISTRICT_INFO:
      return {
        ...state,
        district: action.district,
      };
    case SET_STUDENT_SEARCH_SEARCH_FILTERS:
      return {
        ...state,
        activeFilters: action.filters || state.activeFilters,
      };

    case UPDATE_STUDENT_SEARCH_BUSY_RETRIEVING_STUDENTS:
      return {
        ...state,
        isBusyRetrievingStudents: action.mode,
      };

    case POPULATE_STUDENT_SEARCH_RESULTS:
      return {
        ...state,
        students: action.students || state.students,
        studentCount: action.studentCount,
        hasNextPage: action.hasNextPage || false,
        hasPrevPage: action.hasPrevPage || false,
      };

    case CHANGE_STUDENT_SEARCH_PAGE:
      return {
        ...state,
        page: action.nextPage || 1,
      };

    case CHANGE_STUDENT_SEARCH_STUDENTS_PER_PAGE:
      return {
        ...state,
        studentsPerPage: action.howMany || state.studentsPerPage,
      };

    case CHANGE_STUDENT_SEARCH_SORT_MODE:
      return {
        ...state,
        orderBy: action.fieldName || state.orderBy,
        order: action.direction || state.order,
      };

    case CHANGE_STUDENT_SEARCH_TERM:
      return {
        ...state,
        studentSearchTerm: action.nextTerm || '',
      };

    default:
      return state;
  }
}

export default counselorDashboardReducer;
